<template>
  <van-dialog 
    class="w copyright-dialog--components"
    v-model="localShow" 
    title="版权声明" 
    overlay
    :show-confirm-button='false'
    :close-on-click-overlay='true'
    :before-close='handleClose'>
    <div class="msg">
      本站发布的大部分内容是由其发布者提供，若侵犯到您的权益，请联系站长删除，我们将及时处理。下载资源收集于网络，只做学习和交流使用，版权归原作者所有。若您需要使用非免费的软件或服务，请购买正版授权并合法使用。
    </div>
  </van-dialog>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.localShow = val;
    }
  },
  data() {
    return {
      localShow: this.value,
    }
  },
  methods: {
    handleClose(action, done) {
      done();
      this.$emit("input", false);
    }
  }
};
</script>
<style lang='scss' scoped>
.copyright-dialog--components {
  padding-bottom: 20px;
  .msg {
    margin-top: 10px;
    font-size: $font-size-normal;
    line-height: 30px;
  } 
}
</style>